/* Search results page (sections/main-search.liquid), loaded deferred on the search template only (layout/theme.liquid).
   - Default tab: when the Equipment switch carries data-srch-default (no Equipment value active and both sides have
     products), replace the URL with the Equipment side's. A page this script redirected to never redirects again.
   - Matching categories: fetch sections/search-category-chips.liquid through predictive search once and move its
     [data-srch-cats] into the hero slot. On failure (or no matching collection) the slot stays empty.
   Filters, sort, the switch and pages are handled by assets/collection-filters.js. */
(() => {
  const KEY = 'crawford_srch_default';

  const scope = document.querySelector('[data-srch-default]');
  if (scope) {
    let target = '';
    try {
      const u = new URL(scope.getAttribute('data-srch-default') || '', location.href);
      if (u.origin === location.origin) target = u.pathname + u.search;
    } catch (e) { target = ''; }
    const here = location.pathname + location.search;
    let last = null;
    try { last = sessionStorage.getItem(KEY); } catch (e) { last = null; }
    if (target && target !== here && last !== here) {
      try { sessionStorage.setItem(KEY, target); } catch (e) { return; } // no storage: no loop guard, so no redirect
      location.replace(target);
      return;
    }
  }

  const slot = document.querySelector('[data-srch-cats-slot]');
  if (!slot) return;
  const terms = (slot.dataset.terms || '').trim();
  const base = slot.dataset.url;
  if (!terms || !base) return;

  const url = base + '?q=' + encodeURIComponent(terms) +
    '&resources[type]=collection&resources[limit]=4&section_id=search-category-chips';
  fetch(url, { headers: { Accept: 'text/html' } })
    .then((res) => { if (!res.ok) throw new Error('HTTP ' + res.status); return res.text(); })
    .then((html) => {
      const cats = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-srch-cats]');
      if (cats) slot.replaceChildren(document.adoptNode(cats));
    })
    .catch(() => {});
})();
